import { Component, OnInit, Input } from '@angular/core';
import { TranslationService } from '@sdbn/common';

@Component({
    selector: 'app-report-table',
    templateUrl: './report-table.component.html',
    styleUrls: ['./report-table.component.scss'],
    standalone: false
})
export class ReportTableComponent implements OnInit {

  @Input() title = '';
  @Input() titleDictionaryKey = '';
  @Input() showBorders = false;
  @Input() columnWidth = '100px';
  @Input() columns: Array<any>;
  @Input() rows: Array<any>;
  @Input() hideHeaders: boolean = false;
  @Input() classes: string;

  constructor(
    public translationService: TranslationService) {
  }

  ngOnInit() {
  }

  hasTitle(): boolean {
    return this.title != null && this.title.trim().length > 0;
  }

  hasTitleDictionaryKey(): boolean {
    return this.titleDictionaryKey != null && this.titleDictionaryKey.trim().length > 0;
  }

  hasDictionaryLabel(column: any): boolean {
    return column != null && column.dictionaryKey != null && column.dictionaryKey.trim().length > 0;
  }

  value(rowIndex: number, key: string): any {
    return this.rows[rowIndex][key];
  }

}
